import React from 'react';
import './spinner.scss';

const Spinner = () => {
    return (
        <div className="loading-spinner">
            <i className="fa fa-spinner fa-spin" />
        </div>
    );
};

export default Spinner;
